import { reducersActions } from "../actions/new-actions";

const {
    FETCH_CAMPAIGNS_REQUEST,
    FETCH_CAMPAIGNS_SUCCESS,
    FETCH_CAMPAIGNS_FAILURE,
} = reducersActions;

const initialState = {
  data: [],
  page: 1,
  totalPages: 1,
  loading: false,
  error: null,
};

const campaignFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGNS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
      };
    case FETCH_CAMPAIGNS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default campaignFilterReducer;
